import React from 'react';
import { useParams } from 'react-router-dom';
import {
  useAdmin,
  useChain,
  useScionStrategies,
  useScionVault,
} from '@sc1/common/hooks';
import type { BoxProps } from 'theme-ui';
import { VaultPageTabs } from './VaultPageTabs';

type TTab = 'vault' | 'info' | 'performance' | 'admin' | 'strategies';
interface VaultPageTabsProps extends BoxProps {
  tab?: TTab;
}

export const ScionVaultPageTabs = ({
  tab,
  ...props
}: VaultPageTabsProps): JSX.Element => {
  const { vaultAddress } = useParams();
  const { isAdmin } = useAdmin();

  const chain = useChain();
  const vault = useScionVault(vaultAddress);
  const { strategies } = useScionStrategies(chain, vault);

  return (
    <VaultPageTabs
      tab={tab}
      strategies={strategies}
      isAdmin={!!isAdmin}
      {...props}
    />
  );
};
